module.exports = __webpack_public_path__ + "static/media/galerija_2019 (42).952032bf.jpg";